import object from '@mailobj-browser/front/js/utils/object.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'

const context = [object(), object()]

export const init = (handler, allowed) => {
  context.splice(0, 2, handler, object(null, allowed))
  Object.freeze(context)
}

export const permissions = () => context.at(-1)

export const request = async (...names) => {
  const [promise, { resolve, reject }] = resolvable()
  const [permissions] = context
  const requested = names.flat(Infinity).map(mapper).filter(Boolean)
  
  permissions.requestPermissions(requested, resolve, reject)

  return promise
}

const mapper = name => {
  const [permissions, allowed] = context

  if (Object.hasOwn(allowed, name)) {
    return permissions[name]
  }
}
